import { EnvironmentRepository } from 'core/repositories/EnvironmentRepository';
import { createDependency } from 'services/createDependency';

export const [useEnvironmentRepository, withEnvironmentRepository] = createDependency<EnvironmentRepository>();
